<template>
  <div class="how-it-works">
    <h2 class="how-it-works__title">Come funziona</h2>

    <pointer-list orientation="horizontal" :steps="steps" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'how-it-works',

    computed: {
      ...mapState('livegift', ['products']),

      // quante card si possono scegliere non è un dato di copy: lo dice il
      // catalogo, come per il titolo del carousel. Sotto le due card il numero
      // non si scrive: `products` è vuoto anche prima che il catalogo risolva
      // e senza sessione welfare, dove la sezione resta comunque a video
      choice() {
        if (this.products.length < 2) return 'Scegli la card Vadobay';
        return `Scegli una delle ${this.products.length} card Vadobay disponibili`;
      },

      // i 5 passi del flusso di acquisto (testi dal Figma)
      steps() {
        return [
          {
            title: 'Scegli la card',
            text: `${this.choice} e l’importo che desideri.`,
          },
          {
            title: 'Paga con welfare aziendale',
            text: 'Conferma l\'acquisto utilizzando il tuo saldo welfare.',
          },
          {
            title: 'Ricevi la card',
            text: 'Troverai subito nella tua casella email la tua card e le istruzioni per l\'uso.',
          },
          {
            title: 'Usala quando vuoi',
            text: `Hai ben ${VALIDITY_MONTHS} mesi per utilizzare la tua card, in tutto il mondo.`,
          },
          {
            title: 'Viaggia e divertiti!',
            text: 'E se resta credito nella card, lo usi per il prossimo viaggio.',
          },
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>

  .how-it-works {

    &__title {
      margin: 0 0 $grid-gutter-width;
      font-size: $font-size-base * 1.625;
      font-weight: $vb-font-weight-semibold;
      line-height: 32px;
      color: $gray-900;
      text-align: center;
    }
  }
</style>